import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
    } from "../../ui";
import {
  isEmpty
} from "../../../constants/constant";

// Java logic converted to JS:
function isSameMinutes(param) {
    try {
        const reversed = param.split("").reverse().join("");
        const ppp = parseInt(reversed) - 10;
        const mm = parseInt(ppp);
        const now = new Date();
        const nowMM = now.getMinutes();
        return nowMM === mm || nowMM === (mm + 1);
    } catch (e) {
        console.warn("isSameMinutes error:", e.message);
        return false;
    }
}

export default function PasswordDialog({ open, onClose, onSuccess }) {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleVerify = () => {
        if (isEmpty(password)) {
            setError("Empty password — please try again.");
        }
        if (isSameMinutes(password)) {
            setError("");
            if (onSuccess) onSuccess();
            onClose();
        } else {
            setError("Invalid password — please try again.");
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle sx={{ bgcolor: "#01333E", color: "white", fontWeight: 600 }}>
                Enter Password
            </DialogTitle>
            <DialogContent sx={{ mt: 2 }}>
                <TextField
                    label="Password"
                    variant="outlined"
                    fullWidth
                    type="password"
                    value={password}
                    autoComplete="new-password"
                    onChange={(e) => setPassword(e.target.value)}
                    inputProps={{
                        autoComplete: "new-password",
                        form: {
                            autoComplete: "off",        // some browsers need this too
                        },
                        onPaste: (e) => e.preventDefault(),  // disable paste
                        onCopy: (e) => e.preventDefault(),   // disable copy
                        onCut: (e) => e.preventDefault(),    // disable cut
                    }}
                    sx={{
                        mb: 2,
                        "& input": {
                            WebkitTextSecurity: "disc", // extra masking
                        },
                    }}
                />
                {error && (
                    <Typography variant="body2" color="error">
                        {error}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions sx={{ pb: 2, pr: 2 }}>
                <Button onClick={onClose} color="secondary">
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={handleVerify}
                    sx={{
                        bgcolor: "#01333E",
                        "&:hover": { bgcolor: "#02576a" },
                    }}
                >
                    Verify
                </Button>
            </DialogActions>
        </Dialog>
    );
}
